<script>

export default class PlayerCharacter{
  constructor() {
    this.playerCoords = [0,0]
    this.sprite = new Image();
    this.hit = false; //true if bullet hit player
  }
}
</script>